import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ palette, custom, shape }: Theme) => ({
  root: {
    width: '100%',
  },
  searchIcon: {
    color: palette.primary.main,
  },
  popupIndicator: {
    color: custom.grey[19],
    '&:hover': {
      background: 'transparent',
    },
  },
  inputRoot: {
    paddingTop: '8.5px !important',
    paddingBottom: '8.5px !important',
    paddingLeft: '12px !important',
  },
  paper: {
    boxShadow: '0 5px 20px 0 rgba(32, 49, 91, 0.2)',
    borderRadius: shape.borderRadius,
  },
  listbox: {
    maxHeight: '45vh',
    '&::-webkit-scrollbar': {
      width: 6,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: custom.grey[11],
      borderRadius: 3,
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },
  },
}));
